import Vue from 'vue'

import theme from '@/assets/scss/_theme.scss'
import http from '@/plugins/api/index.js'

Vue.prototype.$theme = theme
Vue.prototype.$http = http